"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var cov_t4y2572vq = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organization/useOrganization.js";
  var hash = "44da066c05a45141280b820af3e0c147bd4c40ce";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organization/useOrganization.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 17
        },
        end: {
          line: 15,
          column: 22
        }
      },
      "1": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 34
        }
      },
      "2": {
        start: {
          line: 17,
          column: 15
        },
        end: {
          line: 20,
          column: 14
        }
      },
      "3": {
        start: {
          line: 18,
          column: 27
        },
        end: {
          line: 18,
          column: 63
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 26
        }
      },
      "5": {
        start: {
          line: 22,
          column: 16
        },
        end: {
          line: 24,
          column: 14
        }
      },
      "6": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 13
        }
      },
      "7": {
        start: {
          line: 26,
          column: 25
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "8": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 36,
          column: 3
        }
      },
      "9": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 38,
          column: 68
        }
      },
      "10": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "11": {
        start: {
          line: 54,
          column: 0
        },
        end: {
          line: 82,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "useOrganization",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 24
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 29
          },
          end: {
            line: 13,
            column: 30
          }
        },
        loc: {
          start: {
            line: 13,
            column: 48
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 17,
            column: 27
          },
          end: {
            line: 17,
            column: 28
          }
        },
        loc: {
          start: {
            line: 17,
            column: 39
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 28
          },
          end: {
            line: 22,
            column: 29
          }
        },
        loc: {
          start: {
            line: 22,
            column: 34
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 12
          },
          end: {
            line: 27,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 12
          },
          end: {
            line: 27,
            column: 18
          }
        }, {
          start: {
            line: 27,
            column: 22
          },
          end: {
            line: 27,
            column: 43
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 20
          },
          end: {
            line: 38,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 35
          },
          end: {
            line: 38,
            column: 50
          }
        }, {
          start: {
            line: 38,
            column: 53
          },
          end: {
            line: 38,
            column: 68
          }
        }],
        line: 38
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "44da066c05a45141280b820af3e0c147bd4c40ce"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

var _core = require("../../core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function useOrganization(_ref) {
  var organization = _ref.organization,
      config = _ref.config,
      onOrganization = _ref.onOrganization,
      authentication = _ref.authentication;
  cov_t4y2572vq.f[0]++;
  var update = (cov_t4y2572vq.s[0]++, (0, _react.useCallback)(function (_organization) {
    cov_t4y2572vq.f[1]++;
    cov_t4y2572vq.s[1]++;
    onOrganization(_organization);
  }, [onOrganization]));
  var list = (cov_t4y2572vq.s[2]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _organizations;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cov_t4y2572vq.f[2]++;
            cov_t4y2572vq.s[3]++;
            _context.next = 4;
            return (0, _core.getCurrentUserOrgs)({
              config: config
            });

          case 4:
            _organizations = _context.sent;
            cov_t4y2572vq.s[4]++;
            return _context.abrupt("return", _organizations);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [config]));
  var close = (cov_t4y2572vq.s[5]++, (0, _react.useCallback)(function () {
    cov_t4y2572vq.f[3]++;
    cov_t4y2572vq.s[6]++;
    update();
  }, [update]));
  var componentProps = (cov_t4y2572vq.s[7]++, {
    config: (cov_t4y2572vq.b[0][0]++, config) || (cov_t4y2572vq.b[0][1]++, authentication.config),
    authentication: authentication,
    organization: organization,
    onOrganization: update
  });
  var components = (cov_t4y2572vq.s[8]++, {
    view: /*#__PURE__*/_react.default.createElement(_.Organization, componentProps),
    list: /*#__PURE__*/_react.default.createElement(_.CurrentUserOrganizations, componentProps)
  });
  var component = (cov_t4y2572vq.s[9]++, organization ? (cov_t4y2572vq.b[1][0]++, components.view) : (cov_t4y2572vq.b[1][1]++, components.list));
  cov_t4y2572vq.s[10]++;
  return {
    state: organization,
    actions: {
      update: update,
      list: list,
      close: close
    },
    component: component,
    components: components,
    config: config,
    authentication: authentication
  };
}

;
cov_t4y2572vq.s[11]++;
useOrganization.propTypes = {
  /** Organization data to render, if url not provided. */
  organization: _propTypes.default.shape({
    avatar_url: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    full_name: _propTypes.default.string.isRequired,
    id: _propTypes.default.number.isRequired,
    location: _propTypes.default.string.isRequired,
    username: _propTypes.default.string.isRequired,
    visibility: _propTypes.default.string.isRequired,
    website: _propTypes.default.string.isRequired
  }),

  /** Function to call when organization is selected. */
  onOrganization: _propTypes.default.func.isRequired,

  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }),

  /** Organizations data array to render, if urls not provided. */
  organizations: _propTypes.default.array,

  /** Configuration to pass through to the Search/Organizations component. */
  config: _propTypes.default.shape({
    /** Configuration required for Search or Organizations if paths are provided as URL. */
    server: _propTypes.default.string
  }).isRequired
};
var _default = useOrganization;
exports.default = _default;